import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        popup: {
            open: false,
            content: ''
        }
    },
    mutations: {
    },
    getters: {},
    actions: {}
})


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/store.js